/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */

import Vue from 'vue';
import * as mTypes from 'store/mutation-types';

const state = {
  validPermits: [],
  validParkings: [],
  validResidents: [],
  error: '',
};

const getters = {
  validPermits: state => state.validPermits,
  validParkings: state => state.validParkings,
  validResidents: state => state.validResidents,
};

const actions = {
  validatePermit({ commit }, payload) {
    let request;
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    if (payload.type === 'cardNumber') {
      request = Vue.http.get(`${process.env.BACKEND_API_URL}api/${path}/permits?parkingCardNr=${payload.input}`);
    } else if (payload.type === 'carNumber') {
      request = Vue.http.get(`${process.env.BACKEND_API_URL}api/${path}/permits?vehicle=${payload.input}`);
    }
    return request.then((response) => {
      commit(mTypes.DATA_FETCHED, { data: response.data, type: 'permits' });
    })
      .catch(() => {
        commit(mTypes.DATA_ERROR, 'failed to validate permits.');
      });
  },
  validateParkings({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.get(`${process.env.BACKEND_API_URL}api/${path}/parkings?vehicle=${payload.input}`).then((response) => {
      commit(mTypes.DATA_FETCHED, { data: response.data, type: 'parkings' });
    })
      .catch(() => {
        commit(mTypes.DATA_ERROR, 'failed to validate parkings.');
      });
  },
  validateResidents({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.get(`${process.env.BACKEND_API_URL}api/${path}/residents?vehicle=${payload.input}`).then((response) => {
      commit(mTypes.DATA_FETCHED, { data: response.data, type: 'residents' });
    })
      .catch(() => {
        commit(mTypes.DATA_ERROR, 'failed to validate residents.');
      });
  },
};

const mutations = {
  [mTypes.DATA_FETCHED](state, items) {
    if (items.type === 'permits') {
      state.validPermits = items.data.items;
    } else if (items.type === 'parkings') {
      state.validParkings = items.data.items;
    } else if (items.type === 'residents') {
      state.validResidents = items.data.items;
    }
  },
  [mTypes.CLEAR_STATE](state) {
    state.validPermits = [];
    state.validParkings = [];
    state.validResidents = [];
  },
  [mTypes.DATA_ERROR](state, error) {
    state.error = error;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/landlord/validatePermit.js